/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantContattoUpdateDTO
 */
export interface TenantContattoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof TenantContattoUpdateDTO
     */
    cognome?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoUpdateDTO
     */
    ruolo?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoUpdateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoUpdateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoUpdateDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantContattoUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the TenantContattoUpdateDTO interface.
 */
export function instanceOfTenantContattoUpdateDTO(value: object): value is TenantContattoUpdateDTO {
    return true;
}

export function TenantContattoUpdateDTOFromJSON(json: any): TenantContattoUpdateDTO {
    return TenantContattoUpdateDTOFromJSONTyped(json, false);
}

export function TenantContattoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantContattoUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'ruolo': json['ruolo'] == null ? undefined : json['ruolo'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function TenantContattoUpdateDTOToJSON(value?: TenantContattoUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cognome': value['cognome'],
        'nome': value['nome'],
        'ruolo': value['ruolo'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
    };
}

